module.exports = __webpack_public_path__ + "static/media/sympo.8bea407c.png";